export default __webpack_public_path__ + "static/media/times-info.d3b0fefd.svg";